import { CQAppConstant } from "../../../app-constants";
import { CQMasterDataStore } from "../../../store/cq-master-data.store";
import { FormRuleController } from "../form-rule.controller";
import { IToggleJSON, IToggleRuleObject } from "../IRules.interface";

export class CQToggleRuleController extends FormRuleController {
    public ruleJSON: IToggleJSON = {};

    constructor(ruleObject: IToggleRuleObject, toggleRule: string) {
        super();
        this.formRuleJson(ruleObject, toggleRule);
    }

    /**
     * @description forms json to be added in inputrule
     * @param ruleObject contains property to form rule
     * @param toggleRule type of rule
     * @private
     * @memberof CQHiddenRuleController
     */
    private formRuleJson = (ruleObject: IToggleRuleObject, toggleRule: string) => {
        const rules: any = this.formRuleFilter(ruleObject.complexLogicQuery, ruleObject.addedCriterias, ruleObject.shouldSkip);
        return this.ruleJSON = {
            [toggleRule]: {
                fields: rules.fieldsArray,
                filter: rules.filterCriteria
            }
        };
    }

    /**
     * @description adds fields  and criteria in the rule 
     * @param complexLogic rule logic used for criteria fields
     * @param addedCriterias contains property for field selected
     * @param shouldSkip boolean value 
     * @public
     * @memberof CQHiddenRuleController
     */
    public formRuleFilter = (complexLogic: string, addedCriterias: any[], shouldSkip: boolean) => {
        let filterCriteria :any;
        if(shouldSkip){
            filterCriteria = "true"
        }else{
            filterCriteria = this.formFilterString(complexLogic, addedCriterias);
        }
        const fieldsArray: string[] = [];
        addedCriterias.forEach((criteria: any) => {
            const fieldName = criteria.field.split('-')[0];
            if(!fieldsArray.includes(fieldName)){
                if(this.isTemplateNBA(criteria)){
                    fieldsArray.push(fieldName);
                }
            }

            if (criteria.isDynamic
                && criteria.operator !== CQAppConstant.EXISTS
                && criteria.operator !== CQAppConstant.ISEMPTY) {
                // fieldsArray.push(criteria.compareTo);
                const fieldName = criteria.compareTo.split('-')[0];
                if(!fieldsArray.includes(fieldName)){
                    if(this.isTemplateNBA(criteria)){
                        fieldsArray.push(fieldName);
                    }
                }
            }
        });
        return {
            fieldsArray,
            filterCriteria
        };
    }

    /**
     * @description checks whether the template is NBA or not
     * @param criteria contains property for field selected
     * @public
     * @memberof CQHiddenRuleController
     */
    public isTemplateNBA(criteria :any){
        return !(CQMasterDataStore.OutputConfig.cqNBA.quickActions.length>0 && criteria.field.includes('-'))
    }
}